import script from "./HeroBanner.vue?vue&type=script&setup=true&lang=ts"
export * from "./HeroBanner.vue?vue&type=script&setup=true&lang=ts"

import "./HeroBanner.vue?vue&type=style&index=0&id=705cea18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-705cea18"]])

export default __exports__